import "@/App.css";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { NotFound } from "@/components/site/NotFound";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { EditBar } from "@/components/site/EditBar";
import { usePages } from "@/hooks/usePages";
import Destination from "@/pages/Destination";
import { EnquiryProvider } from "@/context/EnquiryContext";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { FloatingCTA } from "@/components/site/FloatingCTA";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import Trips from "@/pages/Trips";
import TripDetail from "@/pages/TripDetail";
import Georgia from "@/pages/Georgia";
import GeorgiaGuide from "@/pages/GeorgiaGuide";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function PublicLayout() {
  return (
    <ContentProvider>
      <EnquiryProvider>
        <SmoothScroll />
        <Navbar />
        <Outlet />
        <Footer />
        <FloatingCTA />
        <EditBar />
      </EnquiryProvider>
    </ContentProvider>
  );
}


// Built-in pages the admin has hidden show the not-found page to visitors (admins still see them).
function Gate({ path, children }) {
  const { isHidden } = usePages();
  const { user } = useAuth();
  return isHidden(path) && user?.role !== "admin" ? <NotFound /> : children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/trips" element={<Gate path="/trips"><Trips /></Gate>} />
            <Route path="/trips/:slug" element={<TripDetail />} />
            <Route path="/georgia" element={<Gate path="/georgia"><Georgia /></Gate>} />
            <Route path="/georgia/visa-guide" element={<Gate path="/georgia/visa-guide"><GeorgiaGuide /></Gate>} />
            <Route path="/contact" element={<Gate path="/contact"><Contact /></Gate>} />
            <Route path="/destinations/:slug" element={<Destination />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
